export default [
  //    - WhatsApp Business API interface
  {
    path: "/whatsapp",
    name: "foravila-whatsapp",
    component: () => import("@/views/whatsapp/WhatsApp.vue"),
    meta: {
      action: "manage",
      resource: "all",
    }
  },
];
